import { getData, postData } from '@/views/mped/services/mped-service';

export const getSprFedSubject = async (args) => {
    return getData({
        url: '/spr-fed-subject-select',
        uuid: '4fffde4a-404a-4bd8-adf3-f344b88f5955',
        fullResponse: true,
        args
    });
};

export const setSprFedSubject = async (args) => {
    return postData({
        url: '/spr-fed-subject-save',
        uuid: 'b10bb6ee-5e0b-4569-9d7a-cf9a53e46ce0',
        args,
        throwError: true
    });
}
